/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReportType } from "~/generated/graphql";
import { formatMachineStyleToken } from "~/tools";

export const reportTypeLabels: Record<ReportType, string> = {
  [ReportType.ResourceListCsvExport]: "Resource Details Report",
  [ReportType.ResourcePackagesComplianceCsvExport]: "Compliance Report",
  [ReportType.EventActionReportCsvExport]: "Event Action Report",
};

function formatFallbackReportTypeLabel(type: ReportType): string {
  return formatMachineStyleToken(type);
}

export function getReportTypeLabel(type: ReportType): string {
  return reportTypeLabels[type] ?? formatFallbackReportTypeLabel(type);
}

export const reportTypeCheckboxes = Object.entries(reportTypeLabels).map(
  ([value, label]) => ({
    value,
    label,
  })
);
